<div
  mat-dialog-title
  style="display: flex; align-items: center; gap: 12px; padding: 24px 24px 16px">
  <mat-icon style="color: #667eea; font-size: 28px; width: 28px; height: 28px">label</mat-icon>
  <h2 style="margin: 0; font-size: 24px; font-weight: 600">{{ isNewDoc ? 'Neues Keyword' : 'Keyword bearbeiten' }}</h2>
</div>

@if(keywordFormGroup){
<mat-dialog-content [formGroup]="keywordFormGroup">
  <div class="inline-fields">
    <mat-form-field
      appearance="outline"
      hideRequiredMarker="true">
      <mat-label>Keyword Name</mat-label>
      <mat-icon matPrefix>title</mat-icon>
      <input
        matInput
        formControlName="keywordName"
        placeholder="z.B. Email Notification BCC" />
      @if(keywordFormGroup.get('keywordName')){
      <mat-error color="warn">
        {{ translations.employeeError }} </mat-error
      >}
    </mat-form-field>
  </div>

  <div class="values-section">
    <h4>
      <mat-icon>list</mat-icon>
      Werte ({{ keywordFormGroup.get('keywordValues')?.value?.length || 0 }})
    </h4>

    <div class="dialog-actions-top">
      <button
        mat-raised-button
        color="primary"
        (click)="addEntry()">
        <mat-icon>add</mat-icon>
        Neuer Wert
      </button>

      @if(keywordFormGroup.get('keywordValues')?.value?.length > 1){
      <button
        mat-stroked-button
        (click)="btnSortValues()">
        <mat-icon>sort</mat-icon>
        Sortieren
      </button>
      }
    </div>

    @if(keywordFormGroup.get('keywordValues')?.value?.length > 0) {
    <table class="dragTable">
      <tbody
        cdkDropList
        (cdkDropListDropped)="dropSortObj($event)">
        @for (entry of keywordFormGroup.get('keywordValues')?.value; track entry; let i = $index) {
        <tr cdkDrag>
          <td
            class="drag-handle"
            cdkDragHandle>
            <mat-icon>drag_indicator</mat-icon>
          </td>
          <td class="value-content">
            <span class="value-name">{{ entry.keywordValueName }}</span>
            @if(entry.description) {
            <span class="subtitle">{{ entry.description }}</span>
            }
          </td>
          <td class="actionCell">
            <button
              mat-icon-button
              (click)="editEntry(entry, i)"
              matTooltip="Bearbeiten">
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="removeEntry(i)"
              matTooltip="Löschen">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
    } @else {
    <div class="empty-state">
      <mat-icon>info_outline</mat-icon>
      <p>Noch keine Werte definiert. Klicken Sie auf "Neuer Wert" um zu beginnen.</p>
    </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-raised-button
    color="primary"
    (click)="trySaveKeyword()"
    [disabled]="keywordFormGroup && keywordFormGroup.invalid">
    <mat-icon>save</mat-icon>
    Speichern
  </button>
  <button
    mat-stroked-button
    color="warn"
    [disabled]="keyword.preventDelete || isNewDoc"
    (click)="btnDelete()">
    <mat-icon>delete</mat-icon>
    Löschen
  </button>
  <button
    mat-stroked-button
    mat-dialog-close>
    <mat-icon>close</mat-icon>
    Abbrechen
  </button>
</mat-dialog-actions>
}
